import { render, staticRenderFns } from "./DocumentFileRow.vue?vue&type=template&id=edab2d6c&scoped=true"
import script from "./DocumentFileRow.vue?vue&type=script&lang=js"
export * from "./DocumentFileRow.vue?vue&type=script&lang=js"
import style0 from "./DocumentFileRow.vue?vue&type=style&index=0&id=edab2d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edab2d6c",
  null
  
)

export default component.exports